import { render, staticRenderFns } from "./TextImageTwoColumn.vue?vue&type=template&id=6e97e826&"
import script from "./TextImageTwoColumn.vue?vue&type=script&lang=js&"
export * from "./TextImageTwoColumn.vue?vue&type=script&lang=js&"
import style0 from "./TextImageTwoColumn.vue?vue&type=style&index=0&id=6e97e826&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports